import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import { DialogStyle } from "constants";
import { GridForm } from "components/Ui/styled";
import { showBackdropLoader, getDialogHeading } from "utils/commonUtils";
import { TimeSlotButton, TimeSlotDialog } from "./subjectsAndTutorsStyled";

const SubjectsAndTutorsTimeSlotsDialog = (props) => {
  const {
    open,
    setOpen,
    isFormLoading,
    timeSlotData = { timeSlots: [] },
  } = props;

  const [groupedTimeSlots, setGroupedTimeSlots] = useState([]);

  useEffect(() => {
    if (timeSlotData.timeSlots) {
      const groupedByDay = timeSlotData.timeSlots.reduce((acc, slot) => {
        const day = slot.dayOfWeek.toLowerCase();
        if (!acc[day]) {
          acc[day] = [];
        }
        acc[day].push(`${slot.startTimeFmt} - ${slot.endTimeFmt}`);
        return acc;
      }, {});

      const formattedData = Object.entries(groupedByDay).map(
        ([day, timeSlots]) => ({
          day: capitalizeFirstLetter(day),
          timeSlots,
          id: day,
        })
      );

      setGroupedTimeSlots(formattedData);
    }
  }, [timeSlotData.timeSlots]);

  const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      {showBackdropLoader(isFormLoading)}
      <TimeSlotDialog
        open={open}
        PaperProps={{
          ...DialogStyle,
        }}
      >
        {getDialogHeading("Time Slots", handleClose)}
        <GridForm container spacing={1}>
          {/* Table Header */}
          <Grid item xs={4} md={3}>
            Day
          </Grid>
          <Grid item xs={8} md={9}>
            Time Slots
          </Grid>
          <Grid item xs={12}>
            <hr />
          </Grid>
          {/* Table Body */}
          {groupedTimeSlots.map((row, index) => (
            <React.Fragment key={index}>
              <Grid item xs={4} md={3}>
                {row.day}
              </Grid>
              <Grid item xs={8} md={9}>
                {row.timeSlots.map((timeSlot, index) => (
                  <TimeSlotButton key={index} variant="outlined" size="small">
                    {timeSlot}
                  </TimeSlotButton>
                ))}
              </Grid>
            </React.Fragment>
          ))}
        </GridForm>
      </TimeSlotDialog>
    </>
  );
};

export default SubjectsAndTutorsTimeSlotsDialog;
